import { z } from 'zod';

const numStr = z
	.string()
	.optional()
	.refine((v) => !v || !isNaN(Number(v)), { message: 'Valor inválido' });

export const SoilAnalysisSchema = z
	.object({
		name: z.string().min(1, 'Nome da amostra é obrigatório'),
		state: z.string().optional(),
		sampledAt: z.string().min(1, 'Data da coleta é obrigatória'),
		property: z.string().min(1, 'Propriedade é obrigatória'),
		area: z.string().min(1, 'Talhão é obrigatório'),
		sector: z.array(z.string()).optional(),
		textureMode: z.enum(['', 'Prem', 'texture', 'clay']),
		Prem: z.string().optional(),
		texture: z.string().optional(),
		clay: z.string().optional(),
		pHagua: z.string().min(1, 'pH Água é obrigatório'),
		note: z.string().optional(),
		Pm1: numStr,
		Pres: numStr,
		K: numStr,
		Ca: numStr,
		Mg: numStr,
		S: numStr,
		Na: numStr,
		B: numStr,
		Cu: numStr,
		Fe: numStr,
		Mn: numStr,
		Zn: numStr,
		MO: numStr,
		pHCaCl2: numStr,
		Al: numStr,
		HAl: numStr,
		SB: numStr,
		ctcE: numStr,
		ctcT: numStr,
		CaMg: numStr,
		satSB: numStr,
		satAl: numStr,
		satCa: numStr,
		satMg: numStr,
		satK: numStr,
	})
	.superRefine((data, ctx) => {
		if (data.textureMode === 'Prem' && !data.Prem) {
			ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'P-rem é obrigatório', path: ['Prem'] });
		}
		if (data.textureMode === 'texture' && !data.texture) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: 'Classe textural é obrigatória',
				path: ['texture'],
			});
		}
		if (data.textureMode === 'clay' && !data.clay) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: '% Argila é obrigatória',
				path: ['clay'],
			});
		}
	});

export const PlantAnalysisSchema = z.object({
	name: z.string().min(1, 'Título é obrigatório'),
	sampleAt: z.string().min(1, 'Data da coleta é obrigatória'),
	culture: z.string().min(1, 'Cultura é obrigatória'),
	region: z.string().optional(),
	property: z.string().min(1, 'Propriedade é obrigatória'),
	area: z.string().min(1, 'Talhão é obrigatório'),
	sector: z.array(z.string()).optional(),
	season: z.string().optional(),
	biennial: z.string().optional(),
	note: z.string().optional(),
	N: z.string().min(1, 'N é obrigatório'),
	P: z.string().min(1, 'P é obrigatório'),
	K: z.string().min(1, 'K é obrigatório'),
	Ca: z.string().min(1, 'Ca é obrigatório'),
	Mg: z.string().min(1, 'Mg é obrigatório'),
	S: z.string().min(1, 'S é obrigatório'),
	B: z.string().min(1, 'B é obrigatório'),
	Cu: z.string().min(1, 'Cu é obrigatório'),
	Fe: z.string().min(1, 'Fe é obrigatório'),
	Mn: z.string().min(1, 'Mn é obrigatório'),
	Zn: z.string().min(1, 'Zn é obrigatório'),
});
